import React, { useReducer } from 'react'

import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    HStack,
    InputRightElement,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link,
    Center,
   
  } from '@chakra-ui/react';
  import { FcGoogle } from 'react-icons/fc';
  import { useToast } from '@chakra-ui/react'
import { FaFacebook } from 'react-icons/fa';
import { SiLinkedin, SiMessenger } from 'react-icons/si';
  import { useState } from 'react';
  import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import axios from "axios"
import Footer from './Footer';
import Navbar2 from './Navbar2';
import { useNavigate } from 'react-router-dom';


const iniitalstate={
  email:"",
  password:"",
  name:"",
  img:""
}
const reducer=(state,action)=>{
 switch(action.type){
  case "email":{
    return {...state,
      email:action.payload
    }
  }
  case "firstname":{
    return {...state,
      name:action.payload
    }
  }
  case "img":{
    return {...state,
      img:action.payload
    }
  }
  case "password":{
    return {...state,
      password:action.payload
    }
  }
  case "reset":{
    return    iniitalstate
  }
  default:{
  return    iniitalstate
  }
 }
}

  export default function SingUpPage() {
    const [showPassword, setShowPassword] = useState(false);
    const [state,dispach]=useReducer(reducer,iniitalstate)
    const toast = useToast()
    let navigate=useNavigate()
    const handleclick= ()=>{
    axios.post("https://actual-shoes-api.onrender.com/users/register",state)
    .then((res)=>{
    // alert("user Register Succesfully 😎")
    toast({
      position: 'top',
      title: 'User Register Succesfully 😎',
     
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
  console.log(res)
  navigate("/login")
    }).catch((err)=>{
      console.log(err.message)
    })
    
     }
    const {email,password,name,img}=state
    return (
        <>
<Navbar2 />
        <Box    bgColor="#f7e9f">
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
        bgColor="#f7e9f"
        >
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading style={{marginTop:"20px"}} fontSize={'4xl'} textAlign={'center'}>
              Sign up
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
             ✌️
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <HStack>
                <Box>
                  <FormControl position="static" id="firstName" isRequired>
                    <FormLabel>UserName</FormLabel>
                    <Input type="text" value={name} onChange={(e)=>dispach({type:"firstname",payload:e.target.value})} />
                  </FormControl>
                </Box>
                <Box>
                  <FormControl position="static" id="lastName">
                    <FormLabel position="static">User Image</FormLabel>
                    <Input position="static" type="file" value={img} onChange={(e)=>dispach({type:"img",payload:e.target.value})} />
                  </FormControl>
                </Box>
              </HStack>
              <FormControl position="static" id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input type="email" value={email} onChange={(e)=>dispach({type:"email",payload:e.target.value})} />
              </FormControl>
              <FormControl position="static" id="password" isRequired>
                <FormLabel position="static">Password</FormLabel>
                <InputGroup position="static">
                  <Input position="static"type={showPassword ? 'text' : 'password'}  value={password} onChange={(e)=>dispach({type:"password",payload:e.target.value})} />
                  <InputRightElement position="static" h={'full'}>
                    <Button position="static"
                      variant={'ghost'}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }>
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button position="static"
                  loadingText="Submitting"
                  size="lg"
                  onClick={handleclick}
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Sign up
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align={'center'}>
                  Already a user? <Link  href={"/login"} color={'blue.400'}>Login</Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
      {/* socal media part Here */}
      <Center p={8} mt={"-8%"}>
      <Stack spacing={2} align={'center'} maxW={'md'} w={'full'}>
        {/* Facebook */}
        <Button position="static" w={'full'} colorScheme={'facebook'} leftIcon={<FaFacebook />}>
          <Center>
            <Text>Continue with Facebook</Text>
          </Center>
        </Button>

        {/* Google */}
        <Button position="static" w={'full'} variant={'outline'} leftIcon={<FcGoogle />}>
          <Center>
            <Text>Sign in with Google</Text>
          </Center>
        </Button>

        {/* LinkedIn */}
        <Button position="static" w={'full'} colorScheme={'messenger'} leftIcon={<SiLinkedin />}>
          <Center>
            <Text>Send to Linkedin</Text>
          </Center>
        </Button>

        {/* Messenger */}
        <Button position="static" w={'full'} colorScheme={'messenger'} leftIcon={<SiMessenger />}>
          <Center>
            <Text>Send to Messenger</Text>
          </Center>
        </Button>
      </Stack>
    </Center>
    </Box>
    <Footer />
      </>
    );
  }